/**
 * @flow
 * @format
 */

import React from 'react';
import _ from 'lodash';
// import cc from 'classcat';
import { InputGroup, Input, InputGroupAddon } from 'reactstrap';
import { createHTMLMarkup, branch } from '~/utils';

// import classes from './InputField.scss';

// import debug from '~/utils/macros/debug.macro';

type PropsType = {
  className?: ?string,
  onChange(): void,
  readOnly: boolean,
  step: ?(string | number),
  style: {},
  type: string,
  unit: ?string,
  value: number | string | null,
};

export class InputField extends React.PureComponent<PropsType> {
  static defaultProps = {
    className: null,
    onChange: () => {},
    readOnly: false,
    step: 'any',
    type: 'text',
    style: {},
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const {
      value,
      readOnly,
      type,
      step,
      onChange,
      unit,
      style,
      className,
    } = this.props;

    const renderUnit = () => (_.isString(unit) ? createHTMLMarkup(unit) : unit);

    return (
      <InputGroup style={style} className={className}>
        {branch(
          value === 'N/A',
          <Input type="text" value={value} disabled={readOnly} />,
          <Input
            type={type}
            step={step || 'any'}
            min={0}
            value={value}
            disabled={readOnly}
            onChange={onChange}
          />,
        )}
        {branch(
          !_.isNil(unit),
          <InputGroupAddon addonType="append">
            <span className="input-group-text">{renderUnit()}</span>
          </InputGroupAddon>,
        )}
      </InputGroup>
    );
  }
}

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField/InputField.js